import {Component} from 'react';
import {Container, Divider, List} from 'semantic-ui-react';
import SectionSelector from './SectionSelector';
import './CustomiseSidePanel.scss';
import PropTypes from 'prop-types';
import PdfUploadContainer from './PdfUploadContainer';
import LockIcon from '../images/LockIcon.svg';

import {SortableContainer, SortableElement} from 'react-sortable-hoc';
import ReportSectionToggleContainer from './ReportSectionToggleContainer';
import { MAX_SIZE } from 'lib/ImageValidators';

const SortableItem = SortableElement(({className, section, index, highlightedSection, onFocusSection}) => {
  return (
    <List.Item
      key={`s.key${index}`}
      className={`${className}  ${(section.url || section.key) === highlightedSection ? 'highlighted' : ''}`}
      onClick={(e) => {
        const classList = e.target.classList;
        if (['item', 'title'].some((c) => classList.contains(c))) {
          onFocusSection(section.url || section.key);
        }
      }}
    >
      { (section.key === 'DISCLAIMER') ?
      <SectionSelector content="Disclaimer" hasDragHandle={true} backgroundImage={LockIcon}/>

      : <SectionSelector content={section.label}
                              actionMenu={
                                <ReportSectionToggleContainer included={section.included}
                                                              sectionKey={section.key}
                                                              sectionUrl={section.url}/>
                              }
                              hasDragHandle={true}/>}
    </List.Item>
  );
});

SortableItem.propTypes = {
  className: PropTypes.string.isRequired,
  section: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  highlightedSection: PropTypes.string,
  onFocusSection: PropTypes.func.isRequired,
};

export const SortableList = SortableContainer(({items, style, highlightedSection, onFocusSection}) => {
  return (
    <List style={style}>
      {items.map((section, index) => (
        <SortableItem key={`item-${index}`}
                      index={index}
                      onFocusSection={onFocusSection}
                      section={section}
                      highlightedSection={highlightedSection}
                      className={'optional' + (section.url ? ' custom' : '')}
        />
      ))}
    </List>
  );
});

class CustomiseSidePanel extends Component {

  static propTypes = {
    sections: PropTypes.array.isRequired,
    onSortEnd: PropTypes.func.isRequired,
    reportType: PropTypes.string.isRequired,
    highlightedSection: PropTypes.string,
    onFocusSection: PropTypes.func.isRequired,
  };

  state = {availableHeight: null};

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    const element = document.querySelector('.footer .bottom.fixed');
    if (element) {
      const computedStyle = window.getComputedStyle(element);
      const availableHeight = window.innerHeight - parseInt(computedStyle.height, 10) || null;
      this.setState({availableHeight});
    }
  };

  onSortEnd = ({oldIndex, newIndex}) => {
    const {reportType, onSortEnd} = this.props;
    onSortEnd(reportType, oldIndex, newIndex);
  };

  render() {
    const {sections, highlightedSection, onFocusSection} = this.props;
    const {availableHeight} = this.state;
    return (
      <div className="report-order-section" style={availableHeight && {maxHeight: availableHeight}}>
        <div className="report-section-title">Report Sections</div>
        <div className="selected-sections">
          <SortableList items={sections}
                        lockAxis="y"
                        onFocusSection={onFocusSection}
                        onSortEnd={this.onSortEnd}
                        useDragHandle={true}
                        helperClass="sidebar-panel-helper"
                        highlightedSection={highlightedSection}
                        style={{marginBottom: '0.3rem'}}/>
        </div>
        <Container className="dropzone" style={{cursor: 'pointer'}}>
          <Divider hidden/>
          <PdfUploadContainer maxSize={MAX_SIZE} />
        </Container>
      </div>
    );
  }
}

export default CustomiseSidePanel;